var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRcs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 572,
    viewBox: "0 0 572 572",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 286,
    cy: 286,
    r: 286,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.484 141.674H239.621C225.137 141.674 213.385 153.425 213.385 167.91V229.127C213.385 248.421 229.072 264.108 248.366 264.108H318.329C337.623 264.108 353.31 248.421 353.31 229.127V167.91C353.31 153.425 341.558 141.674 327.074 141.674H305.211V185.4C305.211 190.21 301.275 194.146 296.465 194.146H270.23C265.42 194.146 261.484 190.21 261.484 185.4V141.674ZM160.913 281.599C141.619 281.599 125.932 297.285 125.932 316.58V386.542C125.932 405.836 141.619 421.523 160.913 421.523H248.366C267.661 421.523 283.347 405.836 283.347 386.542V316.58C283.347 297.285 267.661 281.599 248.366 281.599H226.503V325.325C226.503 330.135 222.568 334.07 217.758 334.07H191.522C186.712 334.07 182.777 330.135 182.777 325.325V281.599H160.913ZM318.329 421.523H405.782C425.076 421.523 440.763 405.836 440.763 386.542V316.58C440.763 297.285 425.076 281.599 405.782 281.599H383.918V325.325C383.918 330.135 379.983 334.07 375.173 334.07H348.937C344.127 334.07 340.192 330.135 340.192 325.325V281.599H318.329C310.13 281.599 302.587 284.386 296.629 289.141C299.308 294.826 300.838 301.166 300.838 307.834V395.287C300.838 401.956 299.308 408.296 296.629 413.981C302.587 418.736 310.13 421.523 318.329 421.523Z",
    fill: "#FA0073"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcs);
export default __webpack_public_path__ + "static/media/rcs.c9e003254ddbd619adea4c46be15384d.svg";
export { ForwardRef as ReactComponent };